import {createAction, createAsyncThunk} from "@reduxjs/toolkit";
import PdfCoRequest from "../../api/PdfCoRequest";
import {propOr} from "ramda";
import {getProjectsFromFile} from "./normalize";

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export const clearAllObjectsProject = createAction(
  "project/CLEAR_ALL_OBJECTS_PROJECT",
  () => {
    return {
      payload: {},
    };
  }
);

export const setDraftingObject = createAction(
  "project/SET_DRAFTING_OBJECT",
  (data) => {
    return {
      payload: { data },
    };
  }
);

export const togglePreviewFunc = createAction(
  "project/TOGGLE_PREVIEW_FUNC",
  data => {
    return {
      payload: { data },
    };
  }
);

export const setTestResultUrl = createAction(
  "project/SET_TEST_RESULT_URL",
  (url) => {
    return {
      payload: { url },
    };
  }
);

export const addObjectToProject = createAction(
  "project/ADD_OBJECT_TO_PROJECT",
  (data) => {
    return {
      payload: { data },
    };
  }
);

export const updateObjectProject = createAction(
  "project/UPDATE_OBJECT_PROJECT",
  (data) => {
    return {
      payload: { data },
    };
  }
);

export const addObjectsFromTemplate = createAction(
  "project/ADD_OBJECTS_FROM_TEMPLATE",
  (data) => {

    const sendData = getProjectsFromFile.success(data);
    return {
      payload: { data: sendData },
    };
  }
);

export const removeObjectProject = createAction(
  "project/REMOVE_OBJECT_PROJECT",
  (id) => {
    return {
      payload: { id },
    };
  }
);

export const changeProjectObjectCoordinates = createAction(
  "project/CHANGE_PROJECT_OBJECT_COORDINATES",
  (id, x , y) => {
    return {
      payload: { id, x, y },
    };
  }
);

export const changeProjectObjectSizes = createAction(
  "project/CHANGE_PROJECT_OBJECT_SIZES",
  (id, w , h) => {
    return {
      payload: { id, w, h },
    };
  }
);

export const setJsonTemplateData = createAction(
  "project/SET_JSON_TEMPLATE_DATA",
  (jsonTemplateData) => {
    return {
      payload: { jsonTemplateData },
    };
  }
);

export const checkIfJobIsCompleted = createAsyncThunk(
  "project/CHECK_IF_JOB_IS_COMPLETED",
  async ({ jobId, url }, thunkAPI) => {
    console.debug("[project/CHECK_IF_JOB_IS_COMPLETED]", {
      jobId
    });

    const checkIfJobIsCompletedResponse =
      await PdfCoRequest.checkIfJobIsCompleted({
        jobId,
      });

    console.debug("[project/CHECK_IF_JOB_IS_COMPLETED]", {
      checkIfJobIsCompletedResponse,
    });

    if (checkIfJobIsCompletedResponse.status === "working") {
      await sleep(3000);

      console.debug("[project/CHECK_IF_JOB_IS_COMPLETED -> working]");

      return thunkAPI
        .dispatch(
          checkIfJobIsCompleted({
            jobId
          })
        )
        .unwrap();
    }

    if (checkIfJobIsCompletedResponse.status === "failed") {
      console.debug("[project/CHECK_IF_JOB_IS_COMPLETED -> failed]");

      const message = propOr(
        "Internal error",
        "message",
        checkIfJobIsCompletedResponse
      );

      throw new Error(message);
    }

    if (checkIfJobIsCompletedResponse.status === "success") {
      console.debug("[project/CHECK_IF_JOB_IS_COMPLETED -> success]");
      return { ...checkIfJobIsCompletedResponse };
    }
  }
);

export const fillPdfForm = createAsyncThunk(
  "project/FILL_PDF_FORM",
  async ({ url, data }, thunkAPI) => {
    try {
      const x = await PdfCoRequest.fillPdfForm({
        async: true,
        encrypt: false,
        inline: true,
        url: (url ? url : ""),
        ...data
      });

      return await thunkAPI
        .dispatch(
          checkIfJobIsCompleted({
            jobId: x.jobId,
            url: x.url,
          })
        ).unwrap();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
